import Vue from 'vue'
import Vuetify from 'vuetify'
import VeeValidate from 'vee-validate'
import store from '~/store'
import router from '~/router'
import App from '~/components/App'
import i18n from '~/plugins/i18n'

import '~/plugins'
import '~/components'

import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: {
    primary: '#3d5998', //#1976D2
    secondary: '#37474F', //#424242
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})

Vue.use(VeeValidate, { errorBagName: 'veeErrors' })
VeeValidate.Validator.extend('strong_password', {
  getMessage: field => `The Password field must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character.`,
  validate: value => {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    return strongRegex.test(value);
  }
});

Vue.config.productionTip = false

new Vue({
  i18n,
  store,
  router,
  ...App
})



// WEBPACK FOOTER //
// ./resources/assets/js/app.js